module.exports = __webpack_public_path__ + "static/media/image02.73598af4.png";